import BorderBox from '../components/BorderBox.jsx';
import NowPlaying from '../components/Music/NowPlaying.jsx';
import Playlist from '../components/Music/Playlist.jsx';

export default function MusicPlayerPage() {
  return (
    <div className="flex flex-col lg:grid lg:grid-cols-5 lg:grid-rows-1 gap-4 pb-4 h-[calc(100vh-4rem)]">
      <div className="w-full h-auto lg:h-full lg:col-span-2">
        <BorderBox padding="p-6">
          <NowPlaying />
        </BorderBox>
      </div>
      <div className="w-full h-auto lg:h-full lg:col-span-3">
        <BorderBox padding="p-6" overflow>
          <Playlist />
        </BorderBox>
      </div>
    </div>
  );
}
